<template>
  <div id="box">
    <HeaderView></HeaderView>

    <div class="news-detail">
      <h1 class="news-title">{{ news.titile }}</h1>
      <div class="news-meta">
        <span
          ><img class="date-icon" src="/img/news/images/date_03.png" alt="" />
          {{ news.create_time }}</span
        >
        <span
          ><img class="date-icon" src="/img/news/images/date_03.png" alt="" />
          {{ news.num }}</span
        >
      </div>
      <hr />
      <div class="news-content" v-html="news.content">
        
      </div>
      <div style="margin: 4rem 0; cursor: pointer;" @click="$router.go(-1)">
        <img
          class="back-img"
          src="/img/news/images/redback_03.png"
          alt=""
        />返回
      </div>

      <div class="related-news">
        <div v-if="prev" class="related-item" @click="navigateToNews(prev.id)">
          <img :src="prev.image" alt="" />
          <p>上一篇：{{ prev.titile }}</p>
          <div class="news-meta">
            <span
              ><img
                class="date-icon"
                src="/img/news/images/date_03.png"
                alt=""
              />
              {{ prev.create_time }}</span
            >
            <span
              ><img
                class="date-icon"
                src="/img/news/images/date_03.png"
                alt=""
              />
              {{ prev.views }}</span
            >
          </div>
        </div>
        <div v-if="current" class="related-item" @click="navigateToNews(current.id)">
          <img :src="current.image" alt="" />
          <p>当前篇：{{ current.titile }}</p>
          <div class="news-meta">
            <span
              ><img
                class="date-icon"
                src="/img/news/images/date_03.png"
                alt=""
              />
              {{ current.create_time }}</span
            >
            <span
              ><img
                class="date-icon"
                src="/img/news/images/date_03.png"
                alt=""
              />
              {{ current.views }}</span
            >
          </div>
        </div>
        <div v-if="next" class="related-item" @click="navigateToNews(next.id)">
          <img :src="next.image" alt="" />
          <p>下一篇：{{ next.titile }}</p>
          <div class="news-meta">
            <span
              ><img
                class="date-icon"
                src="/img/news/images/date_03.png"
                alt=""
              />
              {{ next.create_time }}</span
            >
            <span
              ><img
                class="date-icon"
                src="/img/news/images/date_03.png"
                alt=""
              />
              {{ next.views }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "../services/index.js";
import HeaderView from "../components/HeaderView2.vue";
import FooterView from "../components/FooterView.vue";

export default {
  components: {
    HeaderView,
    FooterView,
  },
  data() {
    return {
      news: {},
      prev: null,
      current: null,
      next: null,
      copywriting: {},
    };
  },
  created() {
    const id = this.$route.params.id;
    this.fetchNewsDetail(id);
    window.scrollTo(0, 0);
  },
  beforeRouteUpdate(to, from, next) {
    window.scrollTo(0, 0);
    this.fetchProductData(Number(to.params.id));
    next();
  },
  mounted() {
    this.fetchProductData();
  },
  methods: {
    fetchNewsDetail(id) {
      // 模拟数据，实际可替换为接口请求
      const mockNews = {
      };
      const newsArray = Object.values(mockNews);
      const currentIndex = newsArray.findIndex(n => n.id == id);
      this.news = mockNews[id] || {
        title: "新闻详情",
        date: "",
        views: "0",
        content: "<p>暂无内容</p>",
      };
      this.current = this.news;
      this.prev = currentIndex > 0 ? newsArray[currentIndex - 1] : null;
      this.next = currentIndex < newsArray.length - 1 ? newsArray[currentIndex + 1] : null;
    },
    fetchProductData(id) {
      apiServe.getNewDetail(this.$route.params.id, 'get').then((res) => {
        const newsD = res && res.data && res.data.newsD;
        if (newsD) {
          this.news = newsD;
          this.current = newsD;
        }
        console.log(res, "我是查询接口返回的数据");
      });
      apiServe.getCopyWriting({}, "get").then((res) => {
        this.copywriting = res.data;
      })
    },
    navigateToNews(id) {
      const target = '/news/' + id;
      if (this.$route.path !== target) {
        this.$router.push(target);
      }
    },
    
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>

<style scoped>
::v-deep(.header) {
  position: relative;
}
::v-deep(.date-icon) {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
}
.news-detail {
  width: 70%;

  margin: 2rem auto;
  padding: 0 1rem;
  /* font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; */
}
.news-title {
  font-size: 1.8rem;
  font-weight: 500;
  margin-top: 8rem;

  margin-bottom: 1.5rem;
  color: #333;
}
.news-meta {
  font-size: 0.9rem;
  color: #999;
  margin-bottom: 1.5rem;
}
.news-meta span {
  margin-right: 1rem;
}
.news-content {
  font-size: 1rem;
  line-height: 2.3;
  color: #444;
  letter-spacing: 0.05rem;
}
.news-content p {
  margin-bottom: 1rem;
}
::v-deep(.news-content img) {
  margin: 3rem 0;
  width: 100%;
  height: auto;

}
.back-img {
  width: 1.2rem;
  height: 1.2rem;
  vertical-align: middle;
  margin-right: 1rem;
}
hr {
  /* width: 60%; */
  margin: 2.5rem auto;
  border: 0;
  height: 1px;
  background: #e5e5e5;
}
.related-news {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.related-item {
  width: 27%;

  flex: 1 1 30%;
  cursor: pointer;
}
.related-item>img {
  width: 433px;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
}
.related-item:hover p {
  color: #1890ff;
}
.related-item p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.related-item .news-meta {
  margin-bottom: 1rem;
}
p{
  display: block;
}


/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
    
    .news-detail {
      width: 95%;
      padding: 0;
    }
    .news-title {
      font-size: 1.4rem;
      word-break: break-all;
    }
    .news-content {
      font-size: 0.95rem;
      line-height: 2;
    }
    ::v-deep(.news-content img) {
      width: 100%;
      height: auto;
      margin: 1.5rem 0;
    }
    ::v-deep(.date-icon) {
      width: 0.9rem !important;
      height: 0.9rem !important;
    }
    .back-img {
      width: 1rem;
      height: 1rem;
    }
    .related-news {
      flex-direction: column;
    }
    .related-item {
      width: 100%;

      flex: 1 1 100%;
    }
    .related-item img {
      width: 100%;
      height: auto;
      max-width: 433px;
      max-height: 250px;
    }
  }
  
  /* 更小屏幕微调 */
  @media (max-width: 480px) {
    .news-title {
      font-size: 1.1rem;
      padding: 0;
    }
    .news-content {
      font-size: 0.81rem;
    }
    ::v-deep(.date-icon) {
      width: 0.81rem;
      height: 0.81rem;
    }
    .back-img {
      width: 0.9rem;
      height: 0.9rem;
    }
    .related-item {
      width: 100%;
    }
    .related-item img {
      width: 100%;
      height: auto;
      max-width: 433px;
      max-height: 250px;
    }
  }
</style>